module.exports = __webpack_public_path__ + "static/media/ajb-one-small-min.fd4b3ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/ajb/ajb-one-small-min.png
// module id = 805
// module chunks = 0